import { createAsyncThunk,createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";
import { message } from "antd";

//CREATE ACTION
export const deleteEmployeeTransportRequest = createAsyncThunk("deleteEmployeeTransportRequest", async (requestId, { rejectWithValue }) => {
    try {
        const response = await axiosHttp.get(`requests/delete/${requestId}`);
        message.success(response.data.message);
        return response.data;
    } catch (err) {
        if (!err.response) {
            throw err;
        }
        message.error(err.response.data.message);
        return rejectWithValue(err.response.data);
    }
});
const EmployeeTransportRequestDeleteSlice = createSlice({
    name: "EmployeeTransportRequestDeleteSlice",
    initialState: {
        isLoading: false,
        isError: false,
        error: null,
        data: null,
    },

    extraReducers: (builder) => {
        builder.addCase(deleteEmployeeTransportRequest.pending, (state, action) => {
            state.isLoading = true;
            state.isError = false;
        });

        builder.addCase(deleteEmployeeTransportRequest.fulfilled, (state, action) => {
            state.isLoading = false;
            state.isError = false;
            state.data = action.payload;
        });

        builder.addCase(deleteEmployeeTransportRequest.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.error = action.payload;
        });
    },
});
export default EmployeeTransportRequestDeleteSlice.reducer;